import { Delivery, DeliveryFilters } from '../../../../app/models/Delivery';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DeliveryFilter from './DeliveryFilter';

interface Props {
    deliveries: Delivery[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    view?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: DeliveryFilters;
    setFilter: (filter: DeliveryFilters) => void;
    callbackSuccess: () => void;
    onSearch: () => void;
}

const DeliveryDataTable = ({
    deliveries,
    totalRows,
    loading = false,
    edit,
    view,
    destroy,
    filter,
    setFilter,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: Delivery) => row.id,
            sortable: true,
            sortField: 'id',
            width: '80px',
            cell: (row: Delivery) => <span>{row.id}</span>
        },
        {
            name: 'Pedido',
            selector: (row: Delivery) => row.sales_order,
            sortable: false,
            width: '150px',
            cell: (row: Delivery) => <span>{row.sales_order}</span>
        },
        {
            name: 'RUT Cliente',
            selector: (row: Delivery) => row.client_rut,
            sortable: false,
            width: '120px',
            cell: (row: Delivery) => <span>{row.client_rut || ''}</span>
        },
        {
            name: 'Cliente',
            selector: (row: Delivery) => row.client,
            sortable: false,
            width: '400px',
            cell: (row: Delivery) => <span>{row.client || ''}</span>
        },
        {
            name: 'Destino',
            selector: (row: Delivery) => row.destination,
            sortable: false,
            cell: (row: Delivery) => <span>{row.destination}</span>
        },
        {
            name: 'Fecha Entrega',
            selector: (row: Delivery) => row.delivery_date,
            sortable: true,
            sortField: 'delivery_date',
            width: '150px',
            cell: (row: Delivery) => <span>{row.delivery_date}</span>
        }, 
        {
            name: 'Estado',
            selector: (row: Delivery) => row.status,
            sortable: true,
            sortField: 'status',
            width: '120px',
            cell: (row: Delivery) => <span dangerouslySetInnerHTML={{ __html: row.status_display || '' }} />
        },
        {
            name: 'Inventario',
            selector: (row: Delivery) => row.is_inventory_processed,
            sortable: true,
            sortField: 'is_inventory_processed',
            width: '100px',
            cell: (row: Delivery) => (
                <span className={`badge bg-${row.is_inventory_processed ? 'success' : 'secondary'}`}>
                    {row.is_inventory_processed ? 'Procesado' : 'Pendiente'}
                </span>
            )
        },
        {
            name: 'Acciones',
            selector: (row: Delivery) => row.id,
            sortable: false,
            width: '150px',
            cell: (row: Delivery) => (
                <div className="">
                    {edit && !row.is_inventory_processed && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row?.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {view && (
                        <ButtonTableAction
                            callbackFunction={() => view(row?.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-primary'}
                            errorMessage={'No se puede ver este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {destroy && !row.is_inventory_processed && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row?.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3 mb-3">
                <div className="col">
                    <DeliveryFilter filter={filter} setFilter={setFilter} onSearch={onSearch} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={deliveries}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default DeliveryDataTable;

